import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "whitespace-nowrap m-0" }
const _hoisted_2 = {
  key: 0,
  class: "whitespace-nowrap m-0"
}
const _hoisted_3 = { class: "text-muted italic" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Số BBKN", -1)
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "whitespace-nowrap text-right font-bold" }
const _hoisted_8 = { class: "whitespace-nowrap m-0" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = {
  key: 0,
  class: "mb-0 text-muted text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmHoanThanh = _resolveComponent("ConfirmHoanThanh")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmHoanThanh, {
      for: 'phieu_nhap',
      "phieu-nhap-data": _ctx.selectingPhieuNhap,
      show: !!_ctx.selectingPhieuNhap,
      "is-approval-flow": _ctx.isApprovalFlow,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectingPhieuNhap = null)),
      onConfirm: _ctx.confirmHoanThanh
    }, null, 8, ["phieu-nhap-data", "show", "is-approval-flow", "onConfirm"]),
    _createVNode(_component_el_table, {
      "empty-text": "Chưa có phiếu nhập kho",
      style: {"width":"100%"},
      size: "medium",
      border: true,
      data: _ctx.items
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(`${_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)}`), 1),
            (scope.row.id)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createElementVNode("small", _hoisted_3, "(" + _toDisplayString(scope.row.id) + ")", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Loại phiếu",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            (!scope.row.id_hop_dong || scope.row.id_hop_dong === 0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "info",
                  "disable-transitions": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Nhập khác ")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "success",
                  "disable-transitions": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" HĐ số " + _toDisplayString(scope.row.id_hop_dong), 1)
                  ]),
                  _: 2
                }, 1024))
          ]),
          _: 1
        }),
        (_ctx.showKhoColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Kho",
              width: "180"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.kho?.ten_kho || scope.row.Kho?.ten_kho || "-"), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { label: "Số phiếu" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.so_phieu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Số BBKN",
          width: "100"
        }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_5, [
              (
              scope.row.id_bien_ban_kiem_nghiem ||
              scope.row.bien_ban_kiem_nghiem
            )
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 0,
                    classes: `rounded-none m-0`,
                    "button-type": _ctx.ButtonsType.PRINT,
                    "color-type": _ctx.ButtonTypeColors.INFO,
                    onClick: ($event: any) => (_ctx.openBienBanPdfViewer(scope.row))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.bien_ban_kiem_nghiem.so_bien_ban ??
                scope.row.so_bien_ban), 1)
                    ]),
                    _: 2
                  }, 1032, ["button-type", "color-type", "onClick"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, "Chưa cập nhật"))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Số hóa đơn" }, {
          default: _withCtx((scope) => [
            _createElementVNode("small", null, _toDisplayString(scope.row.so_hoa_don ? scope.row.so_hoa_don : "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Hoàn thành",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ngay_hoan_thanh
            ? _ctx.formatDisplayingDate(scope.row.ngay_hoan_thanh)
            : "-"), 1)
          ]),
          _: 1
        }),
        (_ctx.showDuyetColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "Duyệt",
              width: "50"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: scope.row.is_approved,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.is_approved) = $event),
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showDuyetColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "GĐ ký",
              width: "50"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  "model-value": !!scope.row.is_admin_signed,
                  disabled: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "Tổng tiền",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.formatAmount(+scope.row.total_import_amount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Trạng thái",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_8, [
              _createVNode(_component_el_button, {
                type: 
              _ctx.mapPhieuNhapXuatStatusToLevelColor(scope.row.processing_status)
            ,
                size: "mini"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mapPhieuNhapXuatStatusToLabel(scope.row.processing_status)), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Người tạo",
          "min-width": "140"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_9, _toDisplayString(scope.row.nguoi_dung?.ho_va_ten || "-"), 1),
            (scope.row.nguoi_dung?.so_dien_thoai)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(scope.row.nguoi_dung.so_dien_thoai), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "50",
          fixed: "right",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getVisibleSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}